import { Route } from '@angular/router';
import {
  controlHubAuthGuard,
  crossAppRedirectGuard,
  guestGuard,
} from '@seatix/shared/data-access/auth';

const authRoutesData = { hideSidenav: true, isAuth: true };
const desktopHidesSidenav = { hideSidenav: true, backButton: true };

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('@seatix/control-hub-shell-feature').then(
        (m) => m.GeneralHubLayoutComponent,
      ),
    children: [
      {
        path: 'auth/login',
        data: authRoutesData,
        canMatch: [guestGuard],
        loadComponent: () =>
          import('@seatix/control-hub-auth-feat-login').then(
            (m) => m.FeatLoginPage,
          ),
      },
      {
        path: 'auth/unauthorized',
        data: authRoutesData,
        canMatch: [guestGuard],
        loadComponent: () =>
          import('@seatix/control-hub-auth-feat-unauthorized').then(
            (m) => m.FeatUnauthorizedPage,
          ),
      },
      {
        path: 'sales',
        data: desktopHidesSidenav,
        canMatch: [crossAppRedirectGuard, controlHubAuthGuard],
        loadChildren: () =>
          import('@seatix/control-hub/box-office/routing').then(
            (m) => m.routes,
          ),
      },
      {
        path: 'box-office',
        data: desktopHidesSidenav,
        canMatch: [crossAppRedirectGuard, controlHubAuthGuard],
        loadChildren: () =>
          import('@seatix/control-hub-cash-drawer-shell').then((m) => m.routes),
      },
      {
        path: 'will-call',
        data: desktopHidesSidenav,
        canMatch: [crossAppRedirectGuard, controlHubAuthGuard],
        loadChildren: () =>
          import('@seatix/control-hub-willcall-routing').then((m) => m.routes),
      },
      {
        path: 'settings',
        canMatch: [crossAppRedirectGuard, controlHubAuthGuard],
        loadChildren: () =>
          import('@seatix/control-hub/settings/routing').then((m) => m.routes),
      },
      {
        path: 'welcome',
        data: { isSeats: true },
        canMatch: [crossAppRedirectGuard, controlHubAuthGuard],
        loadComponent: () =>
          import('./desktop-welcome/desktop-welcome.component').then(
            (m) => m.DesktopWelcomeComponent,
          ),
      },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'welcome',
      },
    ],
  },
];
